if (!customElements.get('rebloom-offer')) customElements.define('rebloom-offer', class extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    this.data = JSON.parse(this.querySelector('[data-offer-data]').textContent);
    this.variants = this.data.variants;
    this.variants.forEach(v => v.plans = v.plans.filter(p => p.recurring));
    const firstAvailable = this.variants.find(v => v.available) || this.variants[0];
    this.picks = [firstAvailable, firstAvailable];
    this.q = s => this.querySelector(s);

    // FIX 1: read whichever bundle is ticked on load (2 pouches by default)
    const packChecked = this.q(`input[name="packs-${this.dataset.section}"]:checked`);
    this.count = packChecked ? Number(packChecked.value) : 1;

    this.money = n => {
      const amount = Number(n || 0) / 100;
      const locale = this.dataset.locale || document.documentElement.lang || 'en';
      const currency = this.dataset.currency || 'GBP';
      try {
        return new Intl.NumberFormat(locale, {style:'currency',currency}).format(amount);
      } catch (error) {
        return `${currency} ${amount.toFixed(2)}`;
      }
    };

    const flavours = this.q('[data-flavours]');
    this.variants.forEach(v => {
      const label = document.createElement('label'); label.className = 'rb-card rb-flavour';
      const input = document.createElement('input'); input.type = 'radio'; input.name = `flavour-${this.dataset.section}`; input.value = v.id; input.checked = v.id === this.picks[0].id;
      const span = document.createElement('span'); span.textContent = v.title;
      label.append(input, span); flavours.append(label);
    });

    this.querySelectorAll('[data-pack]').forEach(select => {
      this.variants.forEach(v => select.add(new Option(v.title, v.id)));
      select.value = this.picks[Number(select.dataset.pack)].id;
    });

    this.querySelectorAll('[data-image]').forEach(button => button.addEventListener('click', () => {
      this.showImage(button.dataset.image, button.dataset.alt);
      this.querySelectorAll('[data-image]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
    }));

    this.addEventListener('change', e => {
      // FIX 2: flavour card sets BOTH pouches, so 2 pouches = 2 of the chosen flavour
      if (e.target.name === `flavour-${this.dataset.section}`) {
        const chosen = this.variants.find(v => v.id === Number(e.target.value));
        this.picks[0] = chosen;
        this.picks[1] = chosen;
        this.querySelectorAll('[data-pack]').forEach(s => s.value = chosen.id);
        this.maybeShowVariantImage();
      }
      if (e.target.name === `packs-${this.dataset.section}`) this.count = Number(e.target.value);
      // Pouch 1 / Pouch 2 dropdowns still allow mixing flavours
      if (e.target.matches('[data-pack]')) {
        this.picks[Number(e.target.dataset.pack)] = this.variants.find(v => v.id === Number(e.target.value));
        this.querySelectorAll('[data-flavours] input').forEach(i => i.checked = Number(i.value) === this.picks[0].id);
        this.maybeShowVariantImage();
      }
      this.update();
    });

    this.form = this.q('form');
    this.update(true);
    this.form?.addEventListener('submit', e => this.submit(e));

    // FIX 4: reset button if customer comes back from cart with the back button
    window.addEventListener('pageshow', e => {
      if (e.persisted) {
        this.busy = false;
        const checked = this.q(`input[name="packs-${this.dataset.section}"]:checked`);
        if (checked) this.count = Number(checked.value);
        this.update();
      }
    });
  }

  maybeShowVariantImage() {
    if (this.picks[0].image && this.q('.rb-gallery').dataset.customGallery !== 'true') this.showImage(this.picks[0].image, this.picks[0].title);
  }

  showImage(src, alt) { const img = this.q('.rb-main-image'); if (img) { img.removeAttribute('srcset'); img.src = src; img.alt = alt; } }

  update(initial = false) {
    const selected = this.picks.slice(0, this.count);
    const nativeId = this.q('[data-native-id]');
    const nativeQuantity = this.q('[data-native-quantity]');
    const nativeSellingPlan = this.q('[data-native-selling-plan]');
    if (nativeId && selected[0]) nativeId.value = selected[0].id;
    if (nativeQuantity) {
      const allSameVariant = selected.length > 0 && selected.every(v => v.id === selected[0].id);
      nativeQuantity.value = allSameVariant ? selected.length : 1;
    }

    const targetId = String(this.count === 1 ? this.data.singlePlanId : this.data.doublePlanId);
    const plans = selected[0].plans.filter(p => String(p.id) === targetId && selected.every(v => v.plans.some(a => a.id === p.id && a.price <= v.price)));
    const sub = this.q('input[value="subscription"]');
    const once = this.q('input[value="once"]');
    const requiresPlan = selected.some(v => v.requiresPlan);
    sub.disabled = !plans.length; once.disabled = requiresPlan;
    if ((initial || requiresPlan) && plans.length) sub.checked = true;
    // FIX 3: if subscription isn't available for this bundle, fall back to one-time
    if (!plans.length && sub.checked && !requiresPlan) once.checked = true;

    this.q('[data-sub-card]').classList.toggle('rb-disabled', !plans.length);
    this.q('[data-sub-note]').hidden = !!plans.length;
    this.subscription = sub.checked;
    this.planId = plans[0]?.id || null;
    if (nativeSellingPlan) {
      nativeSellingPlan.value = this.subscription && this.planId ? this.planId : '';
      nativeSellingPlan.disabled = !(this.subscription && this.planId);
    }

    this.q('.rb-pack-selectors').hidden = this.count !== 2;
    // FIX 5: gift box locks/unlocks via JS too (not just CSS)
    this.q('[data-unlock]')?.classList.toggle('is-locked', this.count !== 2);

    this.q('[data-single]').textContent = this.data.strings[this.subscription ? 'single_sub' : 'single'];
    this.q('[data-double]').textContent = this.data.strings[this.subscription ? 'double_sub' : 'double'];

    const oncePrice = selected.reduce((sum, v) => sum + v.price, 0);
    const subPrice = plans.length ? selected.reduce((sum, v) => sum + v.plans.find(p => p.id === this.planId).price, 0) : 0;
    const total = this.subscription ? subPrice : oncePrice;
    const compare = selected.reduce((sum, v) => {
      const allocation = this.subscription && this.planId ? v.plans.find(p => p.id === this.planId) : null;
      return sum + Math.max(v.compare || 0, allocation?.compare || 0, v.price);
    }, 0);

    this.q('[data-total]').textContent = this.subscription && !plans.length ? '—' : this.money(total);
    this.q('[data-once-price]').textContent = this.money(oncePrice);
    this.q('[data-sub-price]').textContent = plans.length ? this.money(subPrice) : '—';
    this.q('[data-sub-detail]').textContent = this.data.strings[this.count === 1 ? 'monthly' : 'bimonthly'];
    this.q('[data-compare]').textContent = this.money(compare);
    const hasSaving = compare > total && total > 0;
    this.q('[data-compare]').hidden = !hasSaving;
    const percentage = hasSaving ? Math.floor((compare - total) * 100 / compare) : 0;
    this.q('[data-saving]').textContent = this.data.strings.saving.replace('[percent]', percentage);
    this.q('[data-saving]').hidden = !hasSaving || percentage < 1;

    this.valid = selected.every(v => v.available) && (!requiresPlan || this.subscription) && (!this.subscription || !!this.planId);
    this.q('.rb-submit').disabled = !this.valid || !!this.busy;
    this.q('.rb-submit').textContent = this.data.strings[this.busy ? 'adding' : this.valid ? 'add' : 'sold_out'];
  }

  async submit(event) {
    event.preventDefault();
    if (!this.valid || this.busy) return;
    this.busy = true; this.update();
    const error = this.q('.rb-error'); error.hidden = true;
    const items = [];
    this.picks.slice(0, this.count).forEach(v => {
      const existing = items.find(i => i.id === v.id);
      if (existing) existing.quantity++;
      else items.push({id: v.id, quantity: 1, ...(this.subscription ? {selling_plan: this.planId} : {})});
    });
    try {
      const response = await fetch(`${this.dataset.root}cart/add.js`, {method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, body: JSON.stringify({items})});
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || this.data.strings.error);
      window.location.assign(`${this.dataset.root}cart`);
    } catch (e) { error.textContent = e.message || this.data.strings.error; error.hidden = false; this.busy = false; this.update(); }
  }
});